import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import React, { useState } from "react";
import Modal from "./Modal";

export default function CancelPlanModal({ open, onClose, onSubmit, loading }) {
  const [value, setValue] = useState("");
  const disabled = value !== "I understand";

  return (
    <Modal
      startIcon={
        <ExclamationCircleIcon
          aria-hidden="true"
          className="size-8 text-rose-600"
        />
      }
      isSubmitting={loading}
      disabled={disabled}
      onSubmit={onSubmit}
      onClose={onClose}
      open={open}
      title="Cancel Plan?"
      description="This action will cancel your subscription and you will lose
                  access to all your plan features at the end of your current
                  billing cycle."
    >
      <input
        onChange={e => setValue(e.target.value)}
        name="value"
        placeholder="I understand"
        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
      />

      <span className="text-xs mt-2 text-gray-500">
        Please type “I understand” to cancel your subscription
      </span>
    </Modal>
  );
}
